import React from 'react';
import DataFlowOverviewTabContainer from '../../data_flows/cards/DataFlowOverviewTabContainer';
import AclTabViewContainer from '../../elements/aclView/AclTabViewContainer';
import CardDetailView from '../../elements/cards/CardDetailView';
import FlowInsights from './FlowInsights';
import { LinkedFlows } from 'js/components/elements/LinkedFlows';
import StyledFixedPanel from 'new/components/StyledFixedPanel';
import { DataFlowDetailHeader } from './DataFlowDetailHeader';

/**
 * FlowDetailView - Component displaying flow details in a drawer/panel
 *
 * @param {Object} props
 * @param {Object} props.data - Flow data object
 * @param {boolean} [props.insightsOnly] - Legacy prop for backward compatibility.
 *                                        If true, shows only insights tab.
 * @param {string} props.aclQueryMode - ACL query mode for access control
 * @param {string} props.aclResourceType - Resource type for ACL checks
 * @param {Object} props.connectionInfo - Connection metadata
 * @param {string} [props.preSelectedTab] - Tab to preselect
 * @param {Function} props.removeDetailViewCard - Callback to close detail view
 */
class FlowDetailView extends React.Component {
  constructor(props) {
    super(props);

    this._getSelectedCardTabs = this._getSelectedCardTabs.bind(this);
    this._getSelectedCardHeader = this._getSelectedCardHeader.bind(this);
    this._getSelectedCardMeta = this._getSelectedCardMeta.bind(this);
    this._handleCloseDetailClicked = this._handleCloseDetailClicked.bind(this);
  }

  render() {
    const { aclQueryMode, preSelectedTab, data } = this.props;

    return (
      <>
        {data && (
          <div>
            <div className="modal-fader" onClick={this._handleCloseDetailClicked} />
            <StyledFixedPanel>
              <CardDetailView
                data={data}
                tabs={this._getSelectedCardTabs()}
                preSelectedTab={preSelectedTab}
                detailHeaderContent={this._getSelectedCardHeader()}
                getSourceMeta={this._getSelectedCardMeta}
                aclQueryMode={aclQueryMode}
                noHeaderPadding
              />
            </StyledFixedPanel>
          </div>
        )}
      </>
    );
  }

  _handleCloseDetailClicked() {
    this.props.removeDetailViewCard();
  }

  _getSelectedCardTabs() {
    const { aclResourceType, insightsOnly, data } = this.props;
    const insightsTab = {
      tabName: 'Insights',
      tabElement: <FlowInsights />,
    };

    if (insightsOnly) {
      return [insightsTab];
    }

    if (data?.flow_type === 'rag') {
      // RAG flows do not produce per-run flow metrics, so the Insights tab
      // (run history + usage trends) has no meaningful data to show — omit it.
      return [
        {
          tabName: 'Overview',
          tabElement: <DataFlowOverviewTabContainer />,
        },
        {
          tabName: 'Access',
          tabElement: <AclTabViewContainer resourceType={aclResourceType} isFlow={true} />,
        },
      ];
    }

    return [
      {
        tabName: 'Overview',
        tabElement: <DataFlowOverviewTabContainer />,
      },
      insightsTab,
      {
        tabName: 'Access',
        tabElement: <AclTabViewContainer resourceType={aclResourceType} isFlow={true} />,
      },
      {
        tabName: 'Linked Flows',
        tabElement: <LinkedFlows />,
      },
    ];
  }

  _getSelectedCardHeader() {
    return <DataFlowDetailHeader {...this.props} onCloseDrawer={this._handleCloseDetailClicked} />;
  }

  _getSelectedCardMeta() {
    return this.props.connectionInfo;
  }
}

export default FlowDetailView;
